import React from 'react';

const AdminDashboard = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-4xl font-bold text-center mb-8">Admin Dashboard</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold mb-4">Manage Artworks</h3>
            <p className="text-gray-600 mb-4">Add, edit, and organize gallery artworks.</p>
            <button className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
              Manage
            </button>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold mb-4">Exhibitions</h3>
            <p className="text-gray-600 mb-4">Create and manage exhibitions.</p>
            <button className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700">
              Manage
            </button>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold mb-4">Analytics</h3>
            <p className="text-gray-600 mb-4">View visitor statistics and insights.</p>
            <button className="bg-purple-600 text-white px-4 py-2 rounded hover:bg-purple-700">
              View
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;